const routes = [
  {
    index: true,
    label: 'Anh-Quan Pham',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'CV',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Academic',
    path: '/academic',
  },
  {
    label: 'Misc',
    path: '/misc',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
